export const techLogos = {
  react:
    "https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/react/react-original.svg",
  javascript:
    "https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/javascript/javascript-original.svg",
  node: "https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/nodejs/nodejs-original.svg",
  express:
    "https://raw.githubusercontent.com/azharzaman1/svg-icons/main/expressjs-logo.png?raw=true",
  mongodb:
    "https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/mongodb/mongodb-original.svg",
  nextjs:
    "https://raw.githubusercontent.com/azharzaman1/svg-icons/0c1d7035caa5dddeeb4582db0f95dfda1d6cfe36/next-logo.svg",
  html5:
    "https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/html5/html5-original.svg",
  css3: "https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/css3/css3-original.svg",
  tailwind:
    "https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/tailwindcss/tailwindcss-plain.svg",
  bootstrap:
    "https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/bootstrap/bootstrap-plain.svg",
  mui: "https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/materialui/materialui-original.svg",
  figma:
    "https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/figma/figma-original.svg",
  redux:
    "https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/redux/redux-original.svg",
  reactQuery:
    "https://raw.githubusercontent.com/codeByKamran/my-icons/431bbe056f1d25758f6db09f68bcb48258e5253b/react-query.svg?token=AS3WWU6L7QD2GPVPFIUADL3DDCE4W",
  sass: "https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/sass/sass-original.svg",
  heroku:
    "https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/heroku/heroku-original.svg",
  git: "https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/git/git-original.svg",
  jest: "https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/jest/jest-plain.svg",
  firebase:
    "https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/firebase/firebase-plain.svg",
  wordpress:
    "https://raw.githubusercontent.com/azharzaman1/svg-icons/0c1d7035caa5dddeeb4582db0f95dfda1d6cfe36/wordpress-logo.svg",
  graphql:
    "https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/graphql/graphql-plain.svg",
};

export const projectLogos = {
  airbnb:
    "https://raw.githubusercontent.com/azharzaman1/svg-icons/0c1d7035caa5dddeeb4582db0f95dfda1d6cfe36/airbnb.svg",
  code: "https://raw.githubusercontent.com/azharzaman1/svg-icons/0c1d7035caa5dddeeb4582db0f95dfda1d6cfe36/code.svg",
};
